import {RateModelEntity} from "@ots-frontend/ots-data";
import {BaseEntitySelect, BaseEntitySelectProps} from "../base-entity-select";
import {useTranslation} from "react-i18next";

export type BaseRateModelSelectProps = Omit<BaseEntitySelectProps<RateModelEntity>, 'placeholder'> & {
  placeholder?: string
};

export const BaseRateModelSelect = (props: BaseRateModelSelectProps) => {
  const {t} = useTranslation(["common"])

  const {
    placeholder = t<string>("common.entity.ratemodel", "Rate Model") as string
  } = props

  return <BaseEntitySelect {...props} placeholder={placeholder}/>;
};
